import React, { Fragment } from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';
import { Link } from 'react-router-dom';
import { AdminEntity, UserRole } from 'src/firebase/db/Admins';
import Bar from 'src/components/atoms/shapes/Bar';
import { Url } from 'src/constants/Url';
type Props = {
  user: AdminEntity;
  login_shop_id: string;
  isMenuOpen: boolean;
  handleLogOut: () => void;
};

export const Menu = ({ ...props }: Props) => {
  const RenderAdminMenu = () => {
    return (
      <Fragment>
        <h3>管理者メニュー</h3>
        <Link to="/admin">管理者用トップ（途中）</Link>
        <Link to="/admin/pushnotifcation">プッシュ通知</Link>
        <Link to="/admin/shop">登録店舗一覧</Link>
        <Link to="/admin/shop/create">新規店舗作成</Link>
        <Link to="/admin/baked_bread_tags">カテゴリ編集</Link>
        <Link to="/admin/master/tags">ハッシュタグ一覧</Link>
        <Link to="/admin/master/tags/create">ハッシュタグ新規登録</Link>
      </Fragment>
    );
  };
  const RenderShopOwnerMenu = () => {
    return (
      <Fragment>
        <h3>店舗オーナー様向けメニュー</h3>
        <Link to="/notifications/create">新たにパンの焼き上がりをお知らせ</Link>
        <Link to={`/notification_templates`}>テンプレートでパンの焼き上がりをお知らせ</Link>
        <Link to={`/shop/${props.login_shop_id}/search/order_breads`}>配信履歴を確認</Link>
        <Link to={`/shop/${props.login_shop_id}/search/orders`}>注文状況を確認</Link>
        <Link to="/reservations">予約注文アイテムを設定する</Link>
        <Link to="/reservations/history">予約注文の配信履歴を確認</Link>
        <Link to="/reservations/orders">予約注文の注文状況を確認</Link>
        <Link to="/baked_breads">焼き上がりを通知するパンを編集</Link>
        <Link to="/baked_breads/create">焼き上がりを通知するパンの新規登録</Link>
        <Link to={`/shop/${props.login_shop_id}/owners/mail_sender`}>
          取り置き受注通知用メールアドレスの確認
        </Link>
        <Link to={`/shop/${props.login_shop_id}/edit`}>店舗の基本情報を修正</Link>
        <Link to={`/shop/${props.login_shop_id}/bags/edit`}>店舗のレジ袋オプションを修正</Link>
        <Link to={'/revenues'}>売上を確認</Link>
      </Fragment>
    );
  };

  const RenderCommonFooter = () => {
    return (
      <Fragment>
        <h3>ログイン・ログアウト</h3>
        <Link to="/login">ログイン</Link>
        <span onClick={props.handleLogOut} className="is-clickable">
          ログアウト
        </span>
        <div className="bar">
          <Bar />
        </div>
        <a className="company" href={Url.company} target="_blank" rel="noopener noreferrer">
          運営会社
        </a>
        <a className="company" href={Url.support} target="_blank" rel="noopener noreferrer">
          お問い合わせ
        </a>
        <a className="company" href={Url.faq} target="_blank" rel="noopener noreferrer">
          よくあるご質問
        </a>
        <a className="company" href={Url.privacy} target="_blank" rel="noopener noreferrer">
          プライバシーポリシー
        </a>
      </Fragment>
    );
  };

  return (
    <StyledMenu open={props.isMenuOpen}>
      <div className="outer">
        <div id="menu-inner" className="inner">
          <Link to="/">トップページ</Link>
          {props.user.role === UserRole.ADMIN ? <RenderAdminMenu /> : null}
          <RenderShopOwnerMenu />
          <RenderCommonFooter />
        </div>
      </div>
    </StyledMenu>
  );
};

const StyledMenu = styled.nav<{ open: boolean }>`
  display: flex;
  flex-direction: column;
  background: ${StyleConfig.COLOR.ECRU};
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  width: 100%;
  height: 100vh;
  text-align: left;
  padding: ${StyleConfig.HELPER.M12};
  position: fixed;
  top: 52px;
  right: 0;
  z-index: 9;
  overflow-y: hidden;
  padding-bottom: 60px;
  transition: transform 0.3s ease-in-out;
  @supports (-webkit-touch-callout: none) {
    height: -webkit-fill-available;
  }
  a,
  span {
    display: block;
    font-size: 1.2rem;
    text-align: left;
    font-weight: bold;
    color: #0d0c1d;
    text-decoration: none;
    transition: color 0.3s linear;
    &.company {
      font-size: 1rem;
      color: ${StyleConfig.COLOR.TEXT_GRAY};
    }
  }
  .bar {
    margin: ${StyleConfig.HELPER.M16} auto;
  }
  .is-clickable {
    cursor: pointer;
  }
  h3 {
    font-size: 18px;
    line-height: ${24 / 18};
    font-weight: bold;
    color: ${StyleConfig.COLOR.PRIMARY};
    margin: ${StyleConfig.HELPER.M16} auto;
  }
  .outer {
    position: relative;
    width: 100%;
    height: 100vh;
    max-width: ${StyleConfig.SETTING.maxWidth}px;
    margin: 0 auto;
    overflow-y: scroll;
    webkit-overflow-scrolling: touch;
    /* @supports (-webkit-touch-callout: none) {
      height: -webkit-fill-available;
    } */

    .inner {
      height: 100vh;
      .menu {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
`;

export default Menu;
